import React from "react";
import ProductGrid from "../../../components/products/productGrid";
import { Header } from "../../../layouts";
import { Footer, HeroSm } from "../../../components";
import HeroSmall from "../../../components/hero/heroSmall";

const ProductsList = () => {
  return (
    <>
      <Header />
      {/* <HeroSm sub title={"Products list"} /> */}
        <ProductGrid viewType="all" />
      <Footer />
    </>
  );
};

export default ProductsList;
